let menuHeight = 0;

export default function fixedNav(selector = '#header-wrapper') {
	const el = document.querySelector(selector);
	const mainMenu = el.querySelector('#masthead');
	if (!el && !mainMenu) return;

	menuHeight = mainMenu.getBoundingClientRect().height;
	// Recalculate the menu height on window resize
	setSelectorHeight(el, mainMenu);

	const options = {
		root: null,
		rootMargin: '0px',
		threshold: 0,
	};

	function callback(entries, observer) {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				mainMenu.style.top = `-${menuHeight}px`;
				setTimeout(() => {
					mainMenu.removeAttribute('style');
					mainMenu.classList.add('fixed-header');
				}, 100);
			} else {
				mainMenu.classList.remove('fixed-header');
			}
		});
	}

	const observer = new IntersectionObserver(callback, options);
	observer.observe(el);
}

function setSelectorHeight(el, mainMenu) {
	const target = document.documentElement;

	function callback(entries) {
		for (let entry of entries) {
			if (entry.contentBoxSize) {
				menuHeight = mainMenu.getBoundingClientRect().height;
				el.style.height = `${menuHeight}px`;
			}
		}
	}

	const resizeObs = new ResizeObserver(callback);
	resizeObs.observe(target);
}
